module.exports = __webpack_public_path__ + "static/media/contact-mobile.e650c70e.jpg";